import Aden from '@/service';
interface IAccount {
  name: string;
  password: string;
  grant_type: string;
}
interface IBusiness {
  search?: string;
}
export function accountLoginRequest(account: IAccount, asstSystem: string) {
  return Aden.post({
    url: `/auth/oauth/token?client_id=${asstSystem}&client_secret=123456`,
    data: account,
  });
}
export function businessList(data: IBusiness) {
  return Aden.post({
    url: '/api/bar/info/findAffiliatedBar',
    data: data,
  });
}
// 获取对应的商户信息
export function userListInfo(data: { barId: number }) {
  return Aden.post({
    url: '/api/bar/info/getBarInfo',
    data: data,
  });
}
// 获取对应商户权限
// type  0 商户 1 连锁 2 员工
export function userPermissions(data: { type: number }) {
  return Aden.post({
    url: '/api/bar/role/permissions',
    data: data,
  });
}
// 获取短信验证码
export function getPhoneCode(data: any) {
  return Aden.post({
    url: '/auth/oauth/verifyCode',
    data: data,
  });
}
export function verificationCodeLogin(data: any) {
  return Aden.post({
    url: '/auth/oauth/token?client_id=asst-business-system&client_secret=123456',
    data: data,
  });
}
// 退出登录
export function loginOut() {
  return Aden.get({
    url: '/auth/oauth/logout',
  });
}
// 员工登录时获取id
export function getStaffId(data: any) {
  return Aden.get({
    url: `/api/bar/ram/account/info/${data}`,
  });
}
